import { NgStyle } from '@angular/common';
import { Component, computed, input } from '@angular/core';

@Component({
  selector: 'eaa-spinner',
  imports: [NgStyle],
  template: `
    <div [class]="class()" [ngStyle]="{ height: diameterStr(), width: diameterStr() }">
      <span class="visually-hidden">Loading...</span>
    </div>
  `
})
export class SpinnerComponent {
  public diameter = input(20);
  public style = input('primary');
  protected class = computed(() => `spinner-border text-${this.style()}`);
  protected diameterStr = computed(() => `${this.diameter()}px`);
}
